export default class Locale_PushNotificationAnnouncementViewer { 
	DontShowAgain: string = "Don't show again";
	PushNotificationAnnouncementsTitle: string = "Projectum Announcements";
}